$(function () {
    $('.delete-attachment').click(function () {
        var field = $(this).data('field'),
            id = $(this).data('id'),
            table = $(this).data('table'),
            data = {},
            $this = $(this),
            url = '/api/' + table + '/' + id + '/delete-attachment';

        if (!confirm('Delete ' + field + '?')) {
            return false;
        }

        if ($(this).hasClass('delete-audio-attachment')) {
            data[field] = 'delete';
        } else {
            data[field] = { name: '' };
        }

        axios
            .patch(url, data)
            .then(() => {
                $this.parent().remove();
            })
            .catch(() => {
                alertify.error('An error occurred while deleting attachment.');
            });

        return false;
    });
});
